import { imgMap } from '@/utils';

export default {
  data() {
    return {
      appImg: imgMap.interPhone,
    };
  },
};
